import React from 'react';

import mapModifiers from 'utils/functions';

interface LoadingProps {
  variant?: 'fullscreen' | 'default';
  width?: number;
  color?: string;
  borderWidth?: number;
}

const LoadingSpinner: React.FC<LoadingProps> = ({
  variant = 'default', width = 20, color = '#000', borderWidth = 0.13
}) => (
  <div
    className={mapModifiers('a-loadingSpinner', variant)}
    style={
      {
        '--loading-color': color,
        '--loading-size': `${width}px`,
        '--border-width': `${borderWidth}`,
      } as React.CSSProperties
    }
  />
);

export default LoadingSpinner;
